module.exports = __webpack_public_path__ + "img/payment-success.45adab47.jpeg";